import { useState } from 'react';
import { api } from '../../lib/api';
import { useParent } from '../ParentContext';

const day = (ms: number) => new Date(ms).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });

/** On a cancelled family in Admin → Families (#883): when its records go, with Keep longer and Delete now. */
export function FamilyRecordsLine({ familyId, name, records, onChanged }: { familyId: string; name: string; records: { deleteAt: number; deletedAt: number }; onChanged: () => void }) {
  const { toast } = useParent();
  const [busy, setBusy] = useState(false);
  async function act(run: () => Promise<unknown>, done: string) {
    setBusy(true);
    try {
      await run();
      toast({ text: done, tone: 'good' });
      onChanged();
    } catch (e) {
      toast({ text: (e as Error).message, tone: 'alert' });
    } finally {
      setBusy(false);
    }
  }
  if (records.deletedAt) return <p className="muted small">Records deleted {day(records.deletedAt)} after cancelling.</p>;
  return (
    <div className="amb-family">
      <span>
        <strong>Records deleted {day(records.deleteAt)}</strong> <span className="muted small">(cancelled; they can download everything until then)</span>
      </span>
      <button type="button" className="btn small" disabled={busy} onClick={() => act(() => api.post(`/api/admin/families/${familyId}/records-hold`, { days: 30 }), `${name}: records kept 30 more days`)}>
        Keep 30 more days
      </button>
      <button
        type="button"
        className="btn small"
        disabled={busy}
        onClick={() => confirm(`Delete ${name}’s records now? Their children and every record go, and this can’t be undone.`) && act(() => api.post(`/api/admin/families/${familyId}/records-delete`), `${name}: records deleted`)}
      >
        Delete now
      </button>
    </div>
  );
}
